module.exports = __webpack_public_path__ + "img/computer.b16a0a49.png";